export const login = state => {
    var state1 = state.login;
    var ls = localStorage.getItem('login');
    var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
    var loginResponse = localStorageLogin != null ? localStorageLogin : state.login;
    return loginResponse;
};

export const loading = state => {
    return state.loading;
};

export const unauthorized = state => {
    return state.unauthorized;
};

export const sessionExpired = state => {
    return state.sessionExpired;
};

export const getTimeForOtp = state => {
    var state1 = state.timeLeft;
    var ls = localStorage.getItem('timeLeft');
    var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
    var loginResponse = localStorageLogin != null ? localStorageLogin : state.timeLeft;
    return loginResponse;
};

export const eScript = state => {
    return state.eScript;
};

export const patientInfo = state => {
    return state.patientInfo;
};

export const groupRequestDetails = state => {
    var state1 = state.groupRequestDetails;
    var ls = localStorage.getItem('groupRequestDetails');
    var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
    var loginResponse = localStorageLogin != null ? localStorageLogin : state.groupRequestDetails;
    return loginResponse;
};

export const fcmToken = state => {
    var state1 = state.fcmToken;
    var ls = localStorage.getItem('fcmToken');
    var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
    var loginResponse = localStorageLogin != null ? localStorageLogin : state.fcmToken;
    return loginResponse;
};

export const deviceId = state => {
    var state1 = state.deviceId;
    var ls = localStorage.getItem('deviceId');
    var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
    var loginResponse = localStorageLogin != null ? localStorageLogin : state.deviceId;
    return loginResponse;
};

export const groupRequestId = state => {
    var state1 = state.groupRequestId;
    var ls = localStorage.getItem('groupRequestId');
    var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
    var loginResponse = localStorageLogin != null ? localStorageLogin : state.groupRequestId;
    return loginResponse;
};

export const showAlert = state => {
    return state.showAlert;
};

export const fromGroupRequests = state => {
    return state.fromGroupRequests;
};

export const scriptRequestDetails = state => {
    var state1 = state.scriptRequestDetails;
    var ls = localStorage.getItem('scriptRequestDetails');
    var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
    var loginResponse = localStorageLogin != null ? localStorageLogin : state.patientDetails;
    return loginResponse;
};
export const notificationStatus = state => {
    return state.notificationStatus;
};

export const name=state=>{

    var state1 = state.name;
    var ls = localStorage.getItem('phstname');
    var lsname = ls !== null ? ls : state1;
    var pname = lsname != null ? lsname : state.name;
    return pname;
}

export const receivedMessage = state => {
    // console.log("getter receivedMessage",state.receivedMessage)
    var msg=null;
    if(state.receivedMessage){  
        msg=state.receivedMessage
    }
    return msg;
}

export const received=state=>{
    var msg=null;
    if(state.received){
        msg=state.received
    }
    return msg;
}


export const frompath = state => {
    var state1 = state.frompath;
    var ls = localStorage.getItem('fromPath');
    var lspath = ls !== null ? ls : state1;
    var path = lspath != null ? lspath : state.frompath;
    console.log("path",path)
    return path;
};

export const pdetails=state=>{
    var state1 = state.pharmacyData;
    var ls = localStorage.getItem('pDetails');
    var localStoragePharmacyData = ls != null ? JSON.parse(ls) : state1;
    var pdata = localStoragePharmacyData != null ? localStoragePharmacyData : state.pharmacyData;
    return pdata;
};

export const chatIdPayload = state => {
    return state.chatIdPayload;
};